import {StringRule} from '../rules';

const fillPreset = new StringRule('Заполните поле')
    .min(1)
    .final();

export {fillPreset};
